module.exports = __webpack_public_path__ + "img/19.5f938ad5.jpg";